import {Component, inject, OnInit} from '@angular/core';
import {NgForOf} from "@angular/common";
import {Condition} from "../condition";
import {ConditionsService} from "../conditions.service";
import {ConditionCardComponent} from "../condition-card/condition-card.component";
import {UsefulLinksComponent} from "../useful-links/useful-links.component";
import {SeoService} from "../seo-service.service";

@Component({
  selector: 'app-Conditions',
  imports: [
    NgForOf,
    ConditionCardComponent,
    UsefulLinksComponent,
  ],
  templateUrl: './conditions.component.html',
  styleUrl: './conditions.component.scss'
})
export class ConditionsComponent implements OnInit{
  conditionsService = inject(ConditionsService);
  conditionList: Condition[] = [];

  constructor(private seo: SeoService) {

    this.conditionsService.getAllConditions()
      .subscribe({
        next: (conditionList: Condition[]) => {
          this.conditionList = conditionList;
        },
        error: (error) => {
          console.error("Error fetching Conditions:", error);
        }
      });
  }

  // for crawlers
  ngOnInit() {
    this.seo.updateMeta(
      "Endocrine Conditions We Treat | Sydney Advanced Endocrinology",
      "Explore the range of endocrine conditions treated by our Sydney specialists, including diabetes, thyroid disorders, PCOS, osteoporosis, adrenal, pituitary, and hormone disorders."
    );
  }
}

